import React from 'react';
import { CheckCircle2, Store, LayoutDashboard } from 'lucide-react';
import { Button } from '../components/ui';

export default function GraciasSuscripcion() {
  const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="relative group mb-8">
        <div className="absolute -inset-1.5 bg-gradient-to-r from-blue-400 via-indigo-400 to-indigo-500 rounded-full blur opacity-25 pointer-events-none" />
        <div className="relative bg-white/90 backdrop-blur-md border border-slate-200/80 p-3.5 rounded-full shadow-xl">
          <img
            src="/icon-original.png"
            alt="Aye Otero Calzados Logo"
            className="w-20 h-20 object-contain rounded-full bg-white"
            onError={(e) => { (e.target as HTMLImageElement).src = '/icon.png'; }}
          />
        </div>
      </div>

      <div className="bg-emerald-50 border border-emerald-500/20 p-3 rounded-full mb-5">
        <CheckCircle2 className="w-8 h-8 text-emerald-600" />
      </div>

      <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-slate-900 mb-3">
        ¡Gracias por tu pago!
      </h1>
      <p className="text-sm md:text-base text-slate-500 max-w-md mb-10">
        Tu suscripción quedó activa. Ya podés volver a la tienda o entrar al panel de control para seguir gestionando tu cuenta.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-sm">
        <Button href="/" variant="primary" size="lg" leftIcon={<Store className="w-4 h-4" />} className="flex-1">
          Ir a la tienda
        </Button>
        <a
          href={dashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2.5 font-heading font-extrabold rounded-xl active:scale-[0.97] transition-all duration-300 border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-8 py-3.5 text-sm"
        >
          <LayoutDashboard className="w-4 h-4" />
          Ir al panel de control
        </a>
      </div>
    </div>
  );
}
